import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import ComponentSave from "./ComponentSave";
import UploadImage from "./ComponentEditUploadFile";
import GetComponent from "./ComponentGetComponentByID";


const ComponentEdit = () => {

    const {id} = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const [component, setComponent] = useState({});

    let response39 = useInvoke("WebApps", "39", null);
    let response40 = useInvoke("WebApps", "40", null);
    let response43 = useInvoke("WebApps", "43", {"@ComponentId": id});
    
    useEffect(() => {

        //get component categories
        if (response39.data.payload != undefined) {
            let data = JSON.parse(response39.data.payload).data;

            let select = document.getElementById("categoryID");

            let defaultOption = document.createElement('option');
            defaultOption.text = "Select Category";
            defaultOption.value = "";
            select.options.add(defaultOption);

            data.forEach(category => {
                let option = document.createElement('option');
                option.text = category[1];
                option.value = category[0];
                select.options.add(option);
            });
        }

        //get component types
        if (response40.data.payload != undefined) {
            let data = JSON.parse(response40.data.payload).data;

            let select = document.getElementById("typeID");

            let defaultOption = document.createElement('option');
            defaultOption.text = "Select Component Type";
            defaultOption.value = "";
            select.options.add(defaultOption);

            data.forEach(type => {
                let option = document.createElement('option');
                option.text = type[1];
                option.value = type[0];
                select.options.add(option);
            });
        }

        //get component data
        if (response43.data.payload != undefined) {
            let data = JSON.parse(response43.data.payload).data[0];

            handleComponentData(data);
        }

    }, [response39.isPending, response40.isPending, response43.isPending]);

    //set dropdown list positions
    useEffect(() => {

        if(component.ComponentCategoryId) {
            document.getElementById("categoryID").value = component["ComponentCategoryId"];
        }

        if(component.ComponentTypeId) {
            document.getElementById("typeID").value = component["ComponentTypeId"];
        }

    }, [component]);

    const handleComponentData = (data) => {

        setComponent(
            {
                ComponentId: data[0],
                CategoryName: data[1],
                ComponentTypeName: data[2],
                ComponentName: data[3],
                ComponentDescription: data[4],
                CreatedDate: data[5],
                ComponentCategoryId: data[6],
                ComponentTypeId: data[7],
                ImageURL: ("https://dc.cssi.co/Images/" + data[8])
            }
        );
    };


    const handleFormSubmit = (e) => {

        let componentid = id;

        let valid = true;
    
        let componentcategoryid = "";
        if (document.getElementById("categoryID").value == "") {
            valid = false;
            toast.error("Component Category required");
        }
        else {
            componentcategoryid = document.getElementById("categoryID").value;
        }

        let componentname = "";
        if (document.getElementById("componentName").value != "") {
            componentname = document.getElementById("componentName").value;
        }
        else {
            componentname = document.getElementById("componentName").defaultValue;
        }

        let componentdescription = "";
        if (document.getElementById("componentDescription").value != "") {
            componentdescription = document.getElementById("componentDescription").value;
        }
        else {
            componentdescription = document.getElementById("componentDescription").defaultValue;
        }

        let componenttypeid = "";
        if (document.getElementById("typeID").value != "") {
            componenttypeid = document.getElementById("typeID").value;
        }
        else {
            valid = false;
            toast.error("Component Type required");
        }

        let modifiedbyid = user["id"];
        let deleted = "0";

        if (valid) {
            ComponentSave (componentid, componentcategoryid, componentname, componentdescription, modifiedbyid, deleted, componenttypeid);
            handleUpload();
        }
    };

    const handleUpload = (e) => {

        GetComponent(id)
        .then((response) => {
            let breakpoint = "";
            handleComponentData(JSON.parse(response.payload).data[0]);
        });

        UploadImage (document.getElementById("imageupload").files[0], id, user["id"], ).then((response) => {

            if (response.status == 200) {
                toast.success("Success");

                //re-render page
                GetComponent(id)
                .then((response) => {
                    let breakpoint = "";
                    handleComponentData(JSON.parse(response.payload).data[0]);
                });
            } 
            else {
                toast.error("Upload failed.");
            }
        });
    };

    document.title = "Component - Edit";
    return ( 
        <div className="componentEdit">
            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                        <h2>Edit Component</h2>
                        
                        <form id="componentCategoryForm" noValidate="novalidate" autoComplete="off" style={{marginTop: "32px"}}>  
                            <div className="form-group">
                                <label htmlFor="categoryID">Component Category</label>
                                <select className="form-control" id="categoryID" name="categoryID"></select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="componentName">Component Name</label>
                                <input className="form-control" id="componentName" name="componentName" type="text" defaultValue={component["ComponentName"]} autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="componentDescription">Component Description</label>
                                <input className="form-control" id="componentDescription" name="componentDescription" type="text" defaultValue={component["ComponentDescription"]} autoComplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="typeID">Component Type</label>
                                <select className="form-control" id="typeID" name="typeID"></select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="currentURL">Image URL</label>
                                <input type="text" readOnly={true} name="currentURL" id="currentURL"value={component["ImageURL"]} class="form-control" autocomplete="off" />
                            </div>

                            <div style={{display: "flex", flexDirection: "column"}}>
                                <label htmlFor="sprite">Image</label>
                                <img id="sprite" src={component["ImageURL"]} height="280" width="280" style={{boxShadow: "lightgrey 0px 0px 2px 2px"}}></img>
                            </div>

                            <div className="form-group" style={{marginTop: "32px"}}>
                                <label htmlFor="imageupload">Replace Image</label>
                                <label htmlFor="imageupload" style={{color: "grey"}}>ⓘ For best results, use square PNG images</label>
                                <input type="file" name="imageupload" id="imageupload" placeholder="Select a File" class="form-control" autocomplete="off" />
                            </div>
                        </form>    
                        <Link to="/Component" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>                        
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>
                </>
            }

        </div>
     );
}
 
export default ComponentEdit;